import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import globalStyles from '../../Styles/global.module.scss'

import Grid from '@mui/material/Grid2';
import GlobalTabs from '../../Utils/Layout/GlobalTabs/GlobalTabs';
import { members, useIsBelow1200 } from '../../Utils/Constant/Constant';
import AppNavbar from '../../Components/AppNavbar/AppNavbar';


const Member = () => {

    const [currentTab, setCurrentTab] = useState<any>("Users");
    const navigate = useNavigate()
    const location = useLocation();
    const isBelow1200 = useIsBelow1200();


    useEffect(() => {
        const path = location.pathname;

        // Special handling for nested/alternate routes
        if (path.includes("/member/viewUserGroup")) {
            setCurrentTab("User Groups");
            return;
        }

        const matchedTab = members?.find((tab) => path.startsWith(tab.navigation));
        if (matchedTab) {
            setCurrentTab(matchedTab.value);
        }
    }, [location.pathname]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        const selectedTab = members.find((tab) => tab.value == newValue);
        if (selectedTab) {
            navigate(selectedTab.navigation);
            setCurrentTab(newValue);
        }
    };

    return (
        <>
            {!isBelow1200 &&
                <AppNavbar />
            }

            <Grid container className={`${globalStyles.gblWrapperOuterSpacing}`}>
                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 10px" }}>
                    <GlobalTabs
                        tabs={members}
                        currentTab={currentTab}
                        onChange={(event: React.SyntheticEvent, newValue: string) => handleTabChange(event, newValue)}
                        sxTabStyle={{
                            textTransform: 'none',
                            color: '#7E7E7E',
                            marginRight: '20px',
                            fontWeight: 'normal',
                            fontSize: '1rem',
                            '&.Mui-selected': {
                                color: '#ffffff',
                                fontWeight: 'bold',
                            }
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Outlet />
                </Grid>
            </Grid>
        </>
    )
}


export default Member